import Vue from 'vue';

Vue.component('subscription', () =>
    import(/* webpackChunkName: 'subscription' */ './subscription.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/subscription/index.js